<!-- 组合单列表项组件 -->
<template>
  <div class="wrap" @click="$emit('click')">
    <header class="wrap_header">
      <span class="bills">单据：{{ number }}</span>
    </header>
    <div class="wrap_box">
      <div class="wrap_box_item">
        <span class="text">单据金额：</span>
        <span class="des">¥{{ sum }}</span>
      </div>
      <div class="wrap_box_item">
        <span class="text">其他项目：</span>
        <div class="good_detial">
          <span class="des">¥{{ otherItemSum }}</span>
          <span class="des" >
            （<span v-for="(item, index) in otherItemDetails" :key="index">
              {{ item.accountName }}{{ index != otherItemDetails.length - 1 ? "、" : "" }}
            </span>） 
          </span>
        </div>
      </div>
      <div class="wrap_box_item">
        <span class="text">已付金额：</span>
        <span class="des">¥{{ paid }}</span>
      </div>
      <div class="wrap_box_item">
        <span class="text">商品明细：</span>
        <div class="good_detial">
          <span  class="des" v-for="(item, index) in goodsDetails" :key="index">
            {{ item.goodsName }}
            {{ index != goodsDetails.length - 1 ? "|" : "" }}
          </span>
        </div>
      </div>
      <div class="wrap_box_item">
        <span class="text">订单日期：</span>
        <span class="des">{{ date }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };

  },

  //接收参数
  props: {
    number: String,
    sum: Number,
    otherItemSum: Number,
    otherItemDetails: Array,
    paid: Number,
    goodsDetails: Array,
    date: String
  },

  methods: {}
}

</script>
<style lang='scss' scoped>
.wrap {
  width: 9.2rem;
  background: #ffffff;
  box-shadow: 0rem 0.013333rem 0.026667rem 0rem #ebebeb;
  border-radius: 0.266667rem;
  box-sizing: border-box;
  padding-bottom: 0.15rem;
}
.wrap_header {
  display: flex;
  justify-content: space-between;
  padding: 0.466667rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;
}
.bills {
  font-size: 0.373333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.wrap_box {
  padding: 0.32rem 0.32rem 0 0.32rem;
}
.wrap_box_item {
  height: 0.32rem;
  line-height: 0.32rem;
  padding-bottom: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.des {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  padding-right: 2px;
}
.good_detial {
  width: calc(100% - 1.28rem - 1rem);
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>